import React from 'react';
import Layout from '../components/Layout';
import { Crown, Shield, Zap, HeartHandshake } from 'lucide-react';

export default function Informazioni() {
  const items = [
    { icon: Shield, title: 'Sicurezza', desc: 'Password cifrate, connessione HTTPS.' },
    { icon: Zap, title: 'Real-time', desc: 'Chat istantanea con notifiche push.' },
    { icon: HeartHandshake, title: 'Supporto', desc: 'Assistenza diretta con lo staff.' },
  ];

  return (
    <Layout title="Informazioni" showBack backTo="/home">
      <div className="px-5 pt-6 max-w-md mx-auto space-y-6">
        <div className="text-center pt-4">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-[var(--gold-soft)] flex items-center justify-center border border-[var(--gold)]/30 gold-glow">
            <Crown className="w-8 h-8 text-[var(--gold)]" strokeWidth={1.5} />
          </div>
          <h1 className="font-heading text-3xl font-light mt-4">
            Golden <span className="text-[var(--gold)] font-medium">TV</span> Connect
          </h1>
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mt-2">Versione 1.0.0</p>
        </div>

        <p className="text-sm text-white/70 leading-relaxed text-center px-4">
          {"Un'esperienza premium per la comunicazione tra i clienti Golden TV e il team di assistenza."}
          Semplice, sicura, sempre a portata di mano.
        </p>

        <div className="space-y-3">
          {items.map((it) => (
            <div key={it.title} className="card-surface p-4 flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-[var(--bg-elevated)] border border-[var(--border-subtle)] flex items-center justify-center flex-shrink-0">
                <it.icon className="w-5 h-5 text-[var(--gold)]" strokeWidth={1.7} />
              </div>
              <div>
                <div className="font-heading font-medium text-white">{it.title}</div>
                <div className="text-sm text-white/60 mt-0.5">{it.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center text-xs text-white/40 pt-4">
          © 2026 Golden TV Connect
        </div>
      </div>
    </Layout>
  );
}
